import moment from 'moment';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { JsonTimeModelOptions, TimeModelOptions, TimeModelOptionsFromJson } from '../options/time-model-options';
import { PrimitiveModel } from './primitive.model';

export class TimeModel extends PrimitiveModel {
    public constructor(
        public name: string,
        public value = moment.invalid(),
        public options = new TimeModelOptions(),
    ) {
        super(name, value, options);
    }

    /**
     * Convert the internal data into an object suitable for OData exchange with SAP
     *
     * @returns {object} the internal value in a format suitable for SAP
     */
    public getOutModel(): ODataTimeOutModel {
        const outModel: ODataTimeOutModel = {};
        const format = this.options.format;

        // the  GW is expecting null, if no value exists

        outModel[this.name] = this.value.isValid() ? this.value.format(format) : null;

        return outModel;
    }
}

export class TimeModelFromJson extends TimeModel {
    public constructor(data: JsonTimeModel) {
        super(data.name, moment(data.value), new TimeModelOptionsFromJson(data.options));
    }
}

export interface JsonTimeModel {
    name: string;
    value: string;
    options: JsonTimeModelOptions;
}

export interface ODataTimeOutModel extends ODataObject {
    [key: string]: string | null;
}
